import { useEffect, useState, useMemo } from 'react';
export var useMounted = function useMounted() {
  var _useState = useState(false),
      isMounted = _useState[0],
      setIsMounted = _useState[1];

  useEffect(function () {
    setIsMounted(true);
    return function () {
      setIsMounted(false);
    };
  }, []);
  return useMemo(function () {
    return isMounted;
  }, [isMounted]);
};